import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Typography,
} from '@mui/material';
import GridViewIcon from '@mui/icons-material/GridView';
import BarChartIcon from '@mui/icons-material/BarChart';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';

const featuresList = [
  {
    key: 'herd',
    icon: GridViewIcon,
  },
  {
    key: 'data',
    icon: BarChartIcon,
  },
  {
    key: 'financial',
    icon: AccountBalanceWalletIcon,
  },
];

export const PersonasSection: React.FC = () => {
  const { t } = useTranslation(['landing']);
  return (
    <Box
      component="section"
      id="features"
      sx={{
        width: '100%',
        backgroundColor: '#FFFFFF',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 8,
        py: { xs: 8, md: 12 },
        px: { xs: 3, md: 6 },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
          width: '100%',
        }}
      >
        <Typography
          sx={{
            fontFamily: '"New Order", sans-serif',
            fontWeight: 600,
            fontSize: { xs: '24px', md: '36px' },
            lineHeight: '40px',
            color: '#004E64',
            textAlign: 'center',
          }}
        >
          {t('landing:personas_new.title')}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            maxWidth: 672,
            width: '100%',
          }}
        >
          <Typography
            sx={{
              fontFamily: '"Inter", sans-serif',
              fontWeight: 400,
              fontSize: '16px',
              lineHeight: '24px',
              color: '#41484B',
              textAlign: 'center',
              width: '100%',
            }}
          >
            {t('landing:personas_new.subtitle')}
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
          gap: 4,
          width: '100%',
          maxWidth: 1280,
        }}
      >
        {featuresList.map((feature, index) => {
          const IconComponent = feature.icon;
          return (
            <Box
              key={index}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                backgroundColor: '#FFFFFF',
                borderRadius: '16px',
                p: 4,
                gap: 2,
                border: '1px solid #E1E8E7',
                transition: 'all 0.2s ease',
                '&:hover': {
                  boxShadow: '0px 10px 20px -5px rgba(0,0,0,0.05)',
                  transform: 'translateY(-4px)',
                },
              }}
            >
              <Box
                sx={{
                  width: 48,
                  height: 48,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: '#004E64',
                  borderRadius: '12px',
                  mb: 1,
                  '& svg': {
                    color: '#8CF3F3',
                    fontSize: 24,
                  },
                }}
              >
                <IconComponent />
              </Box>
              
              <Typography
                sx={{
                  fontFamily: '"New Order", sans-serif',
                  fontWeight: 600,
                  fontSize: '20px',
                  lineHeight: '28px',
                  color: '#003D4D',
                  textAlign: 'center',
                }}
              >
                {t(`landing:personas_new.features.${feature.key}.title`)}
              </Typography>
              
              <Typography
                sx={{
                  fontFamily: '"Inter", sans-serif',
                  fontWeight: 400,
                  fontSize: '16px',
                  lineHeight: '24px',
                  color: '#41484B',
                  textAlign: 'center',
                }}
              >
                {t(`landing:personas_new.features.${feature.key}.description`)}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};